import { scaleLinear, interpolateHcl } from 'd3';

// Возвращает карту цветов.
function colorScale(domain, range, memoized) {
    const scale = scaleLinear().domain(domain).interpolate(interpolateHcl).range(range);

    if (memoized) {
        const cache = {};
        return function (val) {
            if (!(val in cache)) {
                cache[val] = scale(val);
            }
            return cache[val];
        };
    }
    return scale;
}

export default colorScale;
